import type { ExtractFnReturnType } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { type UseQueryOptions, useQuery } from "react-query";
import { VouchersDistributionsRepository } from "./vouchers-distribution.api";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type QueryFnType = typeof vouchersDistributionsRepository.getVoucherDistribution;
type ApiData = ExtractFnReturnType<QueryFnType>;

type UseGetVoucherDistributionOptions = {
  slug: string;
  config?: UseQueryOptions<ApiData, AxiosError>;
};

export const useGetVoucherDistribution = ({ slug, config }: UseGetVoucherDistributionOptions) => {
  return useQuery<ApiData, AxiosError>({
    queryKey: ["voucherDistribution", slug],
    queryFn: () => vouchersDistributionsRepository.getVoucherDistribution({ slug }),
    ...config,
  });
};
